module.exports = __webpack_public_path__ + "static/media/o14.ddff3cd8.png";